<template>
  <div style="margin-right: 12px">
    <el-select
      v-model="tagCode"
      style="width: 180px"
      filterable
      remote
      clearable=""
      reserve-keyword
      placeholder="请输入标签序号"
      :remote-method="querySearch"
      :loading="loading"
      @change="handleSelect">
      <el-option
        v-for="(item, index) in options"
        :key="index"
        :label="`${item.productName || '未使用'}【${item.tagType }—${item.isSetName}】${userPermission.ENT ? '' : '——' + item.vendorName}`"
        :value="item.tagCode">
      </el-option>
    </el-select>
    <el-dialog
      title="标签信息"
      :visible.sync="visible"
      width="500px"
      append-to-body
      :close-on-press-escape="false"
      @closed="handleClosed">
      <el-form
        ref="ruleForm"
        class="tag-info-form"
        label-width="90px">
        <el-form-item label="商品名称:">{{ info.productName }}</el-form-item>
        <el-form-item
          v-if="info.batchCode"
          label="批次号:">
          <link-route @click.native="linkto">
            {{ info.batchCode }}
          </link-route>
        </el-form-item>
        <el-form-item label="标签码:"> {{ info.tagCode }}</el-form-item>
        <el-form-item label="标签序号:"> {{ info.tagNo }} </el-form-item>
        <el-table
          border
          :data="info.tagTraces">
          <el-table-column
            label="状态"
            width="80"
            prop="phrase">
          </el-table-column>
          <el-table-column
            label="时间"
            width="140">
            <template slot-scope="{row}">
              {{ row.timestamp | dateformat }}
            </template>
          </el-table-column>
          <el-table-column
            label="详情"
            prop="details">
          </el-table-column>
        </el-table>
      </el-form>
      <span slot="footer">
        <el-button
          type="primary"
          @click="visible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
let t = null

export default {
  name: 'TagSearchForm',
  props: {
    vendorId: [String, Number]
  },
  data() {
    return {
      tagCode: '',
      loading: false,
      options: [],
      visible: false,
      info: {}
    }
  },
  computed: {
    ...mapState({
      userPermission: state => state.account.permission
    })
  },
  methods: {
    linkto() {
      this.visible = false
      this.$router.push(`/batch-detail?vendorId=${this.info.vendorId}&batchId=${this.info.batchId}&productId=${this.info.productId}`)
    },
    querySearch(queryString) {
      clearTimeout(t)
      console.log('clearTimeout(t)')
      t = setTimeout(() => {
        console.log('setTimeout(t)')
        // if (queryString && !/^[0-9]+$/g.test(queryString)) {
        //   this.$message.error('只能输入数字')
        //   return
        // }
        if (queryString) {
          this.loading = true
          this.$store.dispatch('label/gettagcodes', {
            payload: {
              tagNo: queryString,
              vendorId: this.vendorId
            },
            success: (res) => {
              this.loading = false
              this.options = res.data.records.map(item => {
                item.tagType = ({
                  1: '定制标签',
                  2: '涂层标签',
                  3: '芯片标签',
                  4: '普通标签',
                  5: '一品一码标签'
                })[item.tagType]
                item.isSetName = item.isSetCode === 0 ? '产品码' : (item.tagSizeType === 1 ? '产品码（套）' : '箱码')
                return item
              })
            },
            fail: () => {
              this.loading = false
              this.options = []
            }
          })
        } else {
          this.options = []
        }
      }, 500)
    },
    handleSelect(tagCode) {
      this.$store.dispatch('label/gettagprofile', {
        payload: {
          tagCode
        },
        success: (res) => {
          this.info = res.data
          this.visible = true
          this.tagCode = ''
        },
        fail: () => { }
      })
    },
    handleClosed() {
      this.info = {}
    }
  }
}
</script>
